import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { ClientGroupsScreen } from '../features/client-groups/ClientGroupsScreen'

export const Route = createFileRoute('/client-groups')({
  validateSearch: (search: Record<string, unknown>): { mapping?: string } => ({
    mapping: typeof search.mapping === 'string' ? search.mapping : undefined,
  }),
  component: GroupsRoute,
})

function GroupsRoute() {
  const { mapping } = Route.useSearch()
  return <RequireAuth><ClientGroupsScreen mappingId={mapping} /></RequireAuth>
}
